// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 1024px) {
  .col-sm-1 {
    width: 8.33%;
  }
  .col-sm-2 {
    width: 16.66%;
  }
  .col-sm-3 {
    width: 25%;
  }
  .col-sm-4 {
    width: 33.33%;
  }
  .col-sm-5 {
    width: 41.66%;
  }
  .col-sm-6 {
    width: 50%;
  }
  .col-sm-7 {
    width: 58.33%;
  }
  .col-sm-8 {
    width: 66.66%;
  }
  .col-sm-9 {
    width: 75%;
  }
  .col-sm-10 {
    width: 83.33%;
  }
  .col-sm-11 {
    width: 91.66%;
  }
  .col-sm-12 {
    width: 100%;
  }
  .col-sm-offset-1 {
    margin-left: 8.33%;
  }
  .col-sm-offset-2 {
    margin-left: 16.66%;
  }
  .col-sm-offset-3 {
    margin-left: 25%;
  }
  .col-sm-offset-4 {
    margin-left: 33.33%;
  }
  .col-sm-offset-5 {
    margin-left: 41.66%;
  }
  .col-sm-offset-6 {
    margin-left: 50%;
  }
  .col-sm-offset-7 {
    margin-left: 58.33%;
  }
  .col-sm-offset-8 {
    margin-left: 66.66%;
  }
  .col-sm-offset-9 {
    margin-left: 75%;
  }
  .col-sm-offset-10 {
    margin-left: 83.33%;
  }
  .col-sm-offset-11 {
    margin-left: 91.66%;
  }
  .col-sm-offset-12 {
    margin-left: 100%;
  }
}
@media (min-width: 1025px) {
  .col-md-1 {
    width: 8.33%;
  }
  .col-md-2 {
    width: 16.66%;
  }
  .col-md-3 {
    width: 25%;
  }
  .col-md-4 {
    width: 33.33%;
  }
  .col-md-5 {
    width: 41.66%;
  }
  .col-md-6 {
    width: 50%;
  }
  .col-md-7 {
    width: 58.33%;
  }
  .col-md-8 {
    width: 66.66%;
  }
  .col-md-9 {
    width: 75%;
  }
  .col-md-10 {
    width: 83.33%;
  }
  .col-md-11 {
    width: 91.66%;
  }
  .col-md-12 {
    width: 100%;
  }
  .col-md-offset-1 {
    margin-left: 8.33%;
  }
  .col-md-offset-2 {
    margin-left: 16.66%;
  }
  .col-md-offset-3 {
    margin-left: 25%;
  }
  .col-md-offset-4 {
    margin-left: 33.33%;
  }
  .col-md-offset-5 {
    margin-left: 41.66%;
  }
  .col-md-offset-6 {
    margin-left: 50%;
  }
  .col-md-offset-7 {
    margin-left: 58.33%;
  }
  .col-md-offset-8 {
    margin-left: 66.66%;
  }
  .col-md-offset-9 {
    margin-left: 75%;
  }
  .col-md-offset-10 {
    margin-left: 83.33%;
  }
  .col-md-offset-11 {
    margin-left: 91.66%;
  }
  .col-md-offset-12 {
    margin-left: 100%;
  }
}
.page-count {
  margin-bottom: 30px;
}
.page-count p {
  margin-bottom: 0;
  margin-top: 35px;
}

.inputCheckboxLabel {
  font-family: "Omnes-ATT-W02", Arial;
  font-size: 14px;
}

.fan-profile, .app-name {
  color: #0568ae !important;
  text-decoration: none;
}

.clearFix {
  padding-top: 30px;
}

.odd {
  background-color: hsl(0, 0%, 95%);
}
.odd .tablehiddendata .hiddenswitch > span {
  background: hsl(0, 0%, 95%);
}
.odd .tablehiddendata .hiddenswitch > div {
  background: hsl(0, 0%, 95%);
}

.searchBy {
  padding-left: 0;
  padding-right: 0;
  position: relative;
  margin: -177px 50px 40px 35px;
}
.searchBy input {
  padding-right: 40px;
  font-family: "Omnes-ATT-W02";
  margin-left: 10px;
}
.searchBy .search-icon {
  margin-top: -27px;
  position: absolute;
  right: 0px;
  top: 99%;
}
.searchBy #searchField::-ms-clear {
  display: none;
}

.searchBox-label {
  padding-bottom: 10px;
  font: 1.6rem "Omnes-ATT-W02-Medium";
}

.search-label {
  padding-bottom: 10px;
  font: 1.6rem "Omnes-ATT-W02-Medium";
}

.captionText {
  width: 47px;
  display: inline-block;
}

.icon-arrows-sort-arrow {
  margin: 0 7px;
}
.icon-arrows-sort-arrow.down {
  margin: 0;
}
.icon-arrows-sort-arrow:before, .icon-arrows-sort-arrow:after {
  font-size: 11px;
  height: 11px;
}
.icon-arrows-sort-arrow:after {
  margin-top: 0px;
  visibility: hidden;
}

.grid-table {
  word-break: break-word;
}

#viewAllLink {
  margin-top: 11px !important;
  margin-bottom: 11px !important;
}

#totalCount {
  margin-top: 16px !important;
  margin-bottom: 18px !important;
}

#recordCount {
  margin-top: 32px !important;
  margin-bottom: 18px !important;
}

.resultcheckbox {
  width: 45px !important;
}

.programNote {
  margin-left: 14px !important;
  margin-right: 7px !important;
  margin-bottom: 10px !important;
  display: inline-block;
}

tr a,
thead a {
  color: #191919;
}
tr a.sort-label,
thead a.sort-label {
  color: hsl(204.9, 94.4%, 35.1%);
}
tr td,
thead td {
  border-left: 1px solid #d2d2d2;
}
tr:last-child td,
thead:last-child td {
  border-bottom: 1px solid #d2d2d2;
}

table td:first-child,
tbody td:first-child {
  border-left: 0;
}

.table {
  margin-bottom: 20px;
  table-layout: fixed;
}
.table td {
  word-wrap: break-word;
}

.pagination {
  margin-bottom: 20px;
}

.go-label input {
  height: 36px;
  margin-left: 5px;
  margin-right: 5px;
  width: 40px;
}
.go-label label {
  margin-top: 13px;
}

.checkbox .skin {
  box-sizing: unset;
}

.checkbox,
.radio {
  display: inline-block;
}

@media (max-width: 1024px) {
  .searchBy {
    padding-left: 0;
    padding-right: 0;
    position: relative;
    margin: -240px 50px 20px 30px;
  }
  .searchBy input {
    padding-right: 40px;
    font-family: "Omnes-ATT-W02";
  }
  .searchBy .search-icon {
    margin-top: -27px;
    position: absolute;
    right: -5px;
  }
  .searchBy #searchField::-ms-clear {
    display: none;
  }
  .search-label {
    font: 1.4rem "Omnes-ATT-W02-Medium";
  }
  .table {
    table-layout: initial;
  }
  .clear-search-link {
    padding: 0 15px;
    text-align: left;
  }
  .search-group {
    padding-top: 80px;
    margin-bottom: 20px;
  }
  .search-result {
    padding-top: 0px !important;
  }
}
.tablehiddendata {
  background-position: left 13px;
  background-repeat: repeat-x;
  background-size: 4px 1px;
  margin: 0;
}
.tablehiddendata .hiddenswitch > span {
  background: white;
  float: left;
  font-family: "Omnes-ATT-W02-Medium";
  padding-right: 7px;
}
.tablehiddendata .hiddenswitch > div {
  background: white;
  float: right;
  padding-left: 7px;
}

.colHeading {
  font-weight: 600;
}

.openhiddenrow {
  border-bottom: 2px solid #ccc;
  border-top: 2px solid #ccc;
}
.openhiddenrow th {
  border: 0;
}
.openhiddenrow td {
  border: 0;
}

.rowdisabled {
  cursor: block;
  opacity: 1;
}

input[disabled] + .skin {
  background-color: #d2d2d2;
}

.contentStyle a {
  color: #191919;
}

.radioStack {
  padding-top: 125px;
}

.expanded-message {
  border-left: 30px solid #BADDF9;
  border-right: 30px solid #BADDF9;
  border-top: 10px solid #BADDF9;
  border-bottom: 10px solid #BADDF9;
  position: relative;
}

.highlight-row {
  background: #BADDF9;
}

.selected {
  background: #BADDF9;
}

.transaction-logs {
  white-space: pre-wrap;
  word-wrap: break-word;
  overflow: auto;
  max-width: 100%;
  padding: 10px;
  box-sizing: border-box;
  max-height: 350px;
  line-height: normal;
  padding-top: 0px;
  margin-top: 0px;
}

.copyLog-icon {
  top: 0;
  width: 24px;
  height: 20px;
  cursor: pointer;
  left: -26px;
  position: absolute;
}

.copy-icon {
  width: 100%;
  background-color: #EBEBEB;
}

.log-heading {
  font-family: ATT Aleck Sans;
  font-weight: 700;
  font-size: 11px;
  line-height: 100%;
  letter-spacing: 0%;
}

.no-border {
  border: none !important;
}

.no-border td,
.no-border tr {
  border: none;
}

.copied-message {
  color: hsl(204.9, 94.4%, 35.1%);
  font-weight: bold;
  margin-left: 10px;
  font-size: 11px;
}

.guide-text {
  font-size: 15px;
}

.icon-toggle {
  padding-left: 5px;
  outline: 0px !important;
}

.icon-toggle:hover {
  cursor: pointer;
}

.data-border {
  border-top: 1px solid #d2d2d2 !important;
}

.hideAction {
  visibility: hidden;
}

.imeiWidth {
  width: 150px;
}

.manufacturerWidth {
  width: 123px;
}

.statusWidth {
  width: 130px;
}

.noData-msg {
  text-align: center !important;
  font-size: 13px;
  position: absolute;
  padding-left: 500px;
}

.headerWidth {
  width: 100px;
}

.dateWidth {
  width: 90px;
}

.modelSubEnrollWidth {
  width: 80px;
  word-break: initial;
}`, "",{"version":3,"sources":["webpack://./src/lib/ng2-sapmp/src/assets/style/mixinfunction.scss","webpack://./src/lib/ng2-sapmp/src/assets/style/variables.scss","webpack://./src/lib/ng2-sapmp/src/ui-components/custom-grid-extended/custom-grid-extended.component.scss"],"names":[],"mappings":"AAwBI;EA4BA;IACE,YClDE;ECAN;EFiDE;IACE,aClDE;ECGN;EF8CE;IACE,UClDE;ECMN;EF2CE;IACE,aClDE;ECSN;EFwCE;IACE,aClDE;ECYN;EFqCE;IACE,UClDE;ECeN;EFkCE;IACE,aClDE;ECkBN;EF+BE;IACE,aClDE;ECqBN;EF4BE;IACE,UClDE;ECwBN;EFyBE;IACE,aClDE;EC2BN;EFsBE;IACE,aClDE;EC8BN;EFmBE;IACE,WClDE;ECiCN;EFqBE;IACE,kBCvDE;ECoCN;EFkBE;IACE,mBCvDE;ECuCN;EFeE;IACE,gBCvDE;EC0CN;EFYE;IACE,mBCvDE;EC6CN;EFSE;IACE,mBCvDE;ECgDN;EFME;IACE,gBCvDE;ECmDN;EFGE;IACE,mBCvDE;ECsDN;EFAE;IACE,mBCvDE;ECyDN;EFHE;IACE,gBCvDE;EC4DN;EFNE;IACE,mBCvDE;EC+DN;EFTE;IACE,mBCvDE;ECkEN;EFZE;IACE,iBCvDE;ECqEN;AACF;AF7CI;EAoCA;IACE,YC9DE;EC0EN;EFbE;IACE,aC9DE;EC6EN;EFhBE;IACE,UC9DE;ECgFN;EFnBE;IACE,aC9DE;ECmFN;EFtBE;IACE,aC9DE;ECsFN;EFzBE;IACE,UC9DE;ECyFN;EF5BE;IACE,aC9DE;EC4FN;EF/BE;IACE,aC9DE;EC+FN;EFlCE;IACE,UC9DE;ECkGN;EFrCE;IACE,aC9DE;ECqGN;EFxCE;IACE,aC9DE;ECwGN;EF3CE;IACE,WC9DE;EC2GN;EFzCE;IACE,kBCnEE;EC8GN;EF5CE;IACE,mBCnEE;ECiHN;EF/CE;IACE,gBCnEE;ECoHN;EFlDE;IACE,mBCnEE;ECuHN;EFrDE;IACE,mBCnEE;EC0HN;EFxDE;IACE,gBCnEE;EC6HN;EF3DE;IACE,mBCnEE;ECgIN;EF9DE;IACE,mBCnEE;ECmIN;EFjEE;IACE,gBCnEE;ECsIN;EFpEE;IACE,mBCnEE;ECyIN;EFvEE;IACE,mBCnEE;EC4IN;EF1EE;IACE,iBCnEE;EC+IN;AACF;AAjJA;EACE,mBAAA;AAmJF;AAjJE;EACE,gBAAA;EACA,gBAAA;AAmJJ;;AA/IA;EACE,mCAAA;EACD,eAAA;AAkJD;;AA/IA;EACI,yBAAA;EACA,qBAAA;AAkJJ;;AA/IA;EACE,iBAAA;AAkJF;;AA/IA;EACE,iCAAA;AAkJF;AA7IM;EACE,2BAAA;AA+IR;AA5IM;EACE,2BAAA;AA8IR;;AAvIA;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,6BAAA;AA0IF;AAxIE;EACE,mBAAA;EACA,4BAAA;EACA,iBAAA;AA0IJ;AAvIE;EACE,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;AAyIJ;AAtIE;EACE,aAAA;AAwIJ;;AArIA;EACE,oBAAA;EACA,mCAAA;AAwIF;;AAtIA;EACE,oBAAA;EACA,mCAAA;AAyIF;;AAvIA;EACE,WAAA;EACA,qBAAA;AA0IF;;AAvIA;EACE,aAAA;AA0IF;AAxIE;EACE,SAAA;AA0IJ;AAxIE;EACE,eAAA;EACA,YAAA;AA0IJ;AAxIE;EACE,eAAA;EACA,kBAAA;AA0IJ;;AAtIA;EACE,sBAAA;AAyIF;;AAtIA;EACE,2BAAA;EACA,8BAAA;AAyIF;;AAtIA;EACA,2BAAA;EACA,8BAAA;AAyIA;;AAtIA;EACE,2BAAA;EACA,8BAAA;AAyIF;;AAtIA;EACE,sBAAA;AAyIF;;AAtIA;EACE,4BAAA;EACA,4BAAA;EACA,8BAAA;EACA,qBAAA;AAyIF;;AApIE;;EACE,cAAA;AAwIJ;AAvII;;EACE,+BAAA;AA0IN;AAtIE;;EACE,8BAAA;AAyIJ;AArII;;EACE,gCAAA;AAwIN;;AAjIE;;EACE,cAAA;AAqIJ;;AAjIA;EACE,mBAAA;EACA,mBAAA;AAoIF;AAlIE;EACE,qBAAA;AAoIJ;;AAhIA;EACE,mBAAA;AAmIF;;AA9HE;EACE,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;AAiIJ;AA9HE;EACE,gBAAA;AAgIJ;;AA7HA;EACE,iBAAA;AAgIF;;AA9HA;;EAEE,qBAAA;AAiIF;;AFhSI;EEmKF;IACE,eAAA;IACA,gBAAA;IACA,kBAAA;IACA,6BAAA;EAiIF;EA/HE;IACE,mBAAA;IACA,4BAAA;EAiIJ;EA9HE;IACE,iBAAA;IACA,kBAAA;IACA,WAAA;EAgIJ;EA5HE;IACE,aAAA;EA8HJ;EA1HA;IACE,mCAAA;EA4HF;EAzHA;IACE,qBAAA;EA2HF;EAxHA;IACE,eAAA;IACA,gBAAA;EA0HF;EAvHA;IACE,iBAAA;IACA,mBAAA;EAyHF;EAtHA;IACE,2BAAA;EAwHF;AACF;AArHA;EAEE,8BAAA;EACA,2BAAA;EACA,wBAAA;EACA,SAAA;AAsHF;AAnHI;EACE,iBAAA;EACA,WAAA;EACA,mCAAA;EACA,kBAAA;AAqHN;AAlHI;EACE,iBAAA;EACA,YAAA;EACA,iBAAA;AAoHN;;AA/GA;EACE,gBAAA;AAkHF;;AA/GA;EACE,6BAAA;EACA,0BAAA;AAkHF;AAhHE;EACE,SAAA;AAkHJ;AA/GE;EACE,SAAA;AAiHJ;;AA7GA;EACE,aAAA;EACA,UAAA;AAgHF;;AA7GA;EACE,yBAAA;AAgHF;;AA5GE;EACE,cAAA;AA+GJ;;AA3GA;EACE,kBAAA;AA8GF;;AA3GA;EACI,+BAAA;EACA,gCAAA;EACA,8BAAA;EACA,iCAAA;EACA,kBAAA;AA8GJ;;AA3GA;EACE,mBAAA;AA8GF;;AA3GA;EACE,mBAAA;AA8GF;;AA3GA;EACE,qBAAA;EACA,qBAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;AA8GF;;AA3GA;EACE,MAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;AA8GF;;AA3GA;EACE,WAAA;EACA,yBAAA;AA8GF;;AA1GA;EACE,2BAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AA6GF;;AA1GA;EACE,uBAAA;AA6GF;;AA1GA;;EAEE,YAAA;AA6GF;;AA1GA;EACE,+BAAA;EACA,iBAAA;EACA,iBAAA;EACA,eAAA;AA6GF;;AA1GA;EACE,eAAA;AA6GF;;AA1GA;EACE,iBAAA;EACA,uBAAA;AA6GF;;AA1GA;EACE,eAAA;AA6GF;;AA1GA;EACE,wCAAA;AA6GF;;AA1GA;EACE,kBAAA;AA6GF;;AA1GA;EACE,YAAA;AA6GF;;AA1GA;EACE,YAAA;AA6GF;;AA1GA;EACE,YAAA;AA6GF;;AA3GA;EACE,6BAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;AA8GF;;AA3GA;EACE,YAAA;AA8GF;;AA3GA;EACE,WAAA;AA8GF;;AA5GA;EACE,WAAA;EACA,mBAAA;AA+GF","sourcesContent":["@import 'variables';\n\n@function color($color-name, $color-variant: null) {\n  // color variant is optional\n  @if ($color-variant != null) {\n    // map inception\n    @return map-get(map-get($colors, $color-name), $color-variant);\n  }@else {\n    @return map-get($colors, $color-name);\n  }\n}\n// buttons building section\n\n$btns: (\n  default: color(default, base),\n  primary: color(primary, base),\n  secondary:  color(secondary, base),\n  inverse: color(inverse, light),\n  success: color(success, base),\n  danger:  color(danger, base)\n);\n\n@mixin respond-to($breakpoint) {\n  @if $breakpoint == 'small' {\n    @media (max-width: 1024px) {\n      @content;\n    }\n  }@else if $breakpoint == 'large' {\n    @media (min-width: 1025px) {\n      @content;\n    }\n  }\n}\n\n@mixin vendor-prefix($name, $value) {\n  @each $vendor in ('-webkit-', '-moz-', '-ms-', '-o-', '') {\n    #{$name}: #{$value};\n  }\n}\n\n\n@mixin placeholder() {\n  color: color(inverse, light) !important;\n  font-family: 'Omnes-ATT-W02-Italic'!important;\n  font-style: normal;\n  opacity: 1;\n  font-size: 16px;\n}\n\n// dynamic\n@include respond-to(small) {\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n@include respond-to (large) {\n  @each $gridname, $gridvalue in $grids {\n    .col-md-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-md-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n","// Global Variables\n@import './../../../../../assets/style/var-config';\n// grids here\n$grids: (\n  1: 8.33%,\n  2: 16.66%,\n  3: 25%,\n  4: 33.33%,\n  5: 41.66%,\n  6: 50%,\n  7: 58.33%,\n  8: 66.66%,\n  9: 75%,\n  10: 83.33%,\n  11: 91.66%,\n  12: 100%\n);\n\n\n// refer http://digitaldesign.web.att.com/getstarted-color.html\n$att-dark-blue: hsl(205, 94%, 35%); // #0568ae\n$f-red: hsl(0, 66%, 49%); // #cf2a2a Functional Red\n$fb-gray: hsl(0, 0%, 95%); // #f2f2f2 Functional background Gray\n$att-dark-gray: hsl(0, 0%, 35%); // #5a5a5a\n$f-green: hsl(150, 100%, 24%); // #007a3e functional Green\n// $att-orange: hsl(30, 100%, 46%); // #ea7400 ATT Orange\n$att-orange: #ea7400; //ATT Orange\n\n// set color map easy use variables\n$primary: $att-orange !default;\n$secondary: $att-dark-blue !default;\n$default: $fb-gray !default;\n$inverse: $att-dark-gray !default;\n$danger: $f-red !default;\n$success: $f-green !default;\n\n\n// color variable map\n$colors: (\n  info: #009fdb,\n  enrolledActive:  #66cc00,\n  enrolledNotActive: #70c5e9,\n  notEnrolled: #fdb91d,\n  outOfCompliance: #cccccc,\n  appleNotinstalled: #fcbb15, \n\n  // Primary - Blue color\n  primary: (\n    base: $primary,\n    light: lighten($primary, 15%),\n    lightest: lighten($primary, 60%),\n    dark: darken($primary, 15%)\n  ),\n\n  // Secondary - Orange color\n  secondary: (\n    base: $secondary,\n    light: lighten($secondary, 15%),\n    lightest: lighten($secondary, 60%),\n    dark: darken($secondary, 15%)\n  ),\n\n  // default - Gray color\n  default: (\n    base: $default,\n    light: lighten($default, 5%), // #fff white\n    dark: darken($default, 12.8%), // #d2d2d2 ATT Light Gray\n    darker: darken($default, 18%) // #c4c4c4\n  ),\n\n  // Inverse - Black color\n  inverse: (\n    base: $inverse,\n    light: lighten($inverse, 11.25%), // #767676 Auxiliary Gray\n    lightest: lighten($inverse, 25%), // #999999\n    lighter: lighten($inverse, 23.4%), // #959595 ATT Gray\n    dark: darken($inverse, 15%), // #333 ATT Dark Gray (2015)\n    darker: darken($inverse, 25.2%), // #191919 Functional Digital Text Black\n    darkest: darken($inverse, 35%) // #000 \n  ),\n\n  // danger - Red color\n  danger: (\n    base: $danger,\n    light: lighten($danger, 15%),\n    dark: darken($danger, 15%)\n  ),\n\n  // success - Green color\n  success: (\n    base: $success,\n    light: lighten($success, 15%),\n    dark: darken($success, 15%)\n  )\n);\n","@import '../../assets/style/mixinfunction';\n\n.page-count {\n  margin-bottom: 30px;\n\n  p {\n    margin-bottom: 0;\n    margin-top: 35px;\n  }\n}\n\n.inputCheckboxLabel{\n  font-family: 'Omnes-ATT-W02', Arial;\n\tfont-size: 14px;\n}\n\n.fan-profile, .app-name{\n    color: #0568ae !important;\n    text-decoration: none;\n}\n\n.clearFix{\n  padding-top: 30px;\n}\n\n.odd {\n  background-color: color(default, base);\n\n  \n   .tablehiddendata{\n    .hiddenswitch {\n      & > span {\n        background: color(default, base);\n        }\n\n      & > div {\n        background: color(default, base);\n        }\n      }\n   }\n\n}\n\n.searchBy  {\n  padding-left: 0;\n  padding-right: 0;\n  position: relative;\n  margin: -177px 50px 40px 35px;\n\n  input {\n    padding-right: 40px;\n    font-family: 'Omnes-ATT-W02';\n    margin-left: 10px;\n  }\n\n  .search-icon {\n    margin-top: -27px; \n    position: absolute;\n    right: 0px;\n    top: 99%;\n  }\n\n  #searchField::-ms-clear{\n    display:none;\n  }\n}\n.searchBox-label{\n  padding-bottom: 10px;\n  font: 1.6rem 'Omnes-ATT-W02-Medium';\n}\n.search-label {\n  padding-bottom: 10px;\n  font: 1.6rem 'Omnes-ATT-W02-Medium';\n}\n.captionText {\n  width: 47px;\n  display: inline-block;\n}\n\n.icon-arrows-sort-arrow {\n  margin: 0 7px;\n\n  &.down {\n    margin: 0;\n  }\n  &:before, &:after {\n    font-size: 11px;\n    height: 11px; \n  }\n  &:after {\n    margin-top: 0px;\n    visibility: hidden;\n  }\n}\n\n.grid-table {\n  word-break: break-word;\n}\n\n#viewAllLink{\n  margin-top: 11px !important;\n  margin-bottom: 11px !important;\n}\n\n#totalCount{\nmargin-top: 16px !important;\nmargin-bottom: 18px !important;\n}\n\n#recordCount {\n  margin-top: 32px !important;\n  margin-bottom: 18px !important;\n}\n\n.resultcheckbox {\n  width: 45px !important;\n}\n\n.programNote{\n  margin-left: 14px !important;\n  margin-right: 7px !important;\n  margin-bottom: 10px !important;\n  display: inline-block;\n}\n\ntr,\nthead {\n  a {\n    color: color(inverse, darker);\n    &.sort-label {\n      color: color(secondary,base);\n    }\n  }\n\n  td {\n    border-left: 1px solid color(default, dark);\n  }\n\n  &:last-child {\n    td {\n      border-bottom: 1px solid color(default, dark);\n    }\n  }\n}\n\ntable,\ntbody {\n  td:first-child {\n    border-left: 0;\n  }\n}\n\n.table {\n  margin-bottom: 20px;\n  table-layout: fixed;\n\n  td {\n    word-wrap: break-word;\n  }\n}\n\n.pagination {\n  margin-bottom: 20px;\n}\n\n.go-label {\n\n  input {\n    height: 36px;\n    margin-left: 5px;\n    margin-right: 5px;\n    width: 40px;\n  }\n\n  label {\n    margin-top: 13px;\n  }\n}\n.checkbox .skin{\n  box-sizing: unset;\n}\n.checkbox,\n.radio {\n  display: inline-block;\n}\n@include respond-to(small) {\n\n  .searchBy  {\n    padding-left: 0;\n    padding-right: 0;\n    position: relative;\n    margin: -240px 50px 20px 30px;\n  \n    input {\n      padding-right: 40px;\n      font-family: 'Omnes-ATT-W02';\n    }\n  \n    .search-icon {\n      margin-top: -27px;\n      position: absolute;\n      right: -5px;\n      //top: 50%;\n    }\n  \n    #searchField::-ms-clear{\n      display:none;\n    }\n  }\n\n  .search-label {\n    font: 1.4rem 'Omnes-ATT-W02-Medium';\n  }\n\n  .table {\n    table-layout: initial;\n  }\n\n  .clear-search-link {\n    padding: 0 15px;\n    text-align: left;\n  }\n\n  .search-group {\n    padding-top: 80px;\n    margin-bottom: 20px;\n  }\n\n  .search-result {\n    padding-top: 0px !important;\n  }\n}\n\n.tablehiddendata {\n  // background-image: url('data:image/svg+xml,<svg%20xmlns%3D\"http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg\"%20version%3D\"1.1\"%20viewport%3D\"0%200%201%201\"%20style%3D\"width%3A100%25%3B%20height%3A1px%3B\"><style>line%7Bstroke%3Argba(153%2C153%2C153%2C1)%3Bstroke-width%3A2%3B%7D<%2Fstyle><line%20y2%3D\"1\"%20y1%3D\"1\"%20x1%3D\"1\"%20x2%3D\"100%25\"%20stroke-dasharray%3D\"1%2C%203\"%2F><%2Fsvg>') !important;\n  background-position: left 13px;\n  background-repeat: repeat-x;\n  background-size: 4px 1px;\n  margin: 0;\n\n  .hiddenswitch {\n    & > span {\n      background: color(default, light);\n      float: left;\n      font-family: 'Omnes-ATT-W02-Medium';\n      padding-right: 7px;\n      }\n\n    & > div {\n      background: color(default, light);\n      float: right;\n      padding-left: 7px;\n      }\n    }\n}\n\n.colHeading {\n  font-weight: 600;\n}\n\n.openhiddenrow {\n  border-bottom: 2px solid #ccc;\n  border-top: 2px solid #ccc;\n\n  th {\n    border: 0;\n    }\n\n  td {\n    border: 0;\n    }\n}\n\n.rowdisabled {\n  cursor: block;\n  opacity: 1;\n}\n\ninput[disabled]+.skin {\n  background-color: color(default, dark);\n}\n\n.contentStyle {\n  a {\n    color: color(inverse, darker);\n  }\n}\n\n.radioStack {\n  padding-top: 125px;\n}\n\n.expanded-message {\n    border-left: 30px solid #BADDF9;\n    border-right: 30px solid #BADDF9;\n    border-top: 10px solid #BADDF9;\n    border-bottom: 10px solid #BADDF9;\n    position: relative;\n}\n\n.highlight-row {\n  background: #BADDF9;\n}\n\n.selected {\n  background: #BADDF9;\n}\n\n.transaction-logs {\n  white-space: pre-wrap;\n  word-wrap: break-word; \n  overflow: auto; \n  max-width: 100%; \n  padding: 10px; \n  box-sizing: border-box; \n  max-height: 350px;\n  line-height: normal;\n  padding-top: 0px;\n  margin-top: 0px;\n}\n\n.copyLog-icon { \n  top: 0;\n  width: 24px;\n  height: 20px;\n  cursor: pointer;\n  left: -26px;\n  position: absolute;  \n}\n\n.copy-icon {\n  width: 100%;\n  background-color: #EBEBEB;\n  ;\n}\n\n.log-heading {\n  font-family: ATT Aleck Sans;\n  font-weight: 700;\n  font-size: 11px;\n  line-height: 100%;\n  letter-spacing: 0%;\n}\n\n.no-border {\n  border: none !important;\n}\n\n.no-border td,\n.no-border tr {\n  border: none;\n}\n\n.copied-message {\n  color:  hsl(204.9, 94.4%, 35.1%);\n  font-weight: bold;\n  margin-left: 10px;\n  font-size: 11px;\n}\n\n.guide-text {\n  font-size: 15px;\n}\n\n.icon-toggle {\n  padding-left: 5px;\n  outline: 0px !important;\n}\n\n.icon-toggle:hover {\n  cursor: pointer;\n}\n\n.data-border {\n  border-top: 1px solid #d2d2d2 !important;;\n}\n\n.hideAction {\n  visibility: hidden;\n}\n\n.imeiWidth {\n  width: 150px;\n}\n\n.manufacturerWidth {\n  width: 123px;\n}\n\n.statusWidth {\n  width: 130px;\n}\n.noData-msg {\n  text-align: center !important;\n  font-size: 13px;\n  position: absolute;\n  padding-left: 500px;\n}\n\n.headerWidth {\n  width: 100px;\n}\n\n.dateWidth {\n  width: 90px;\n}\n.modelSubEnrollWidth {\n  width: 80px;\n  word-break: initial;\n}\n// @include respond-to(small) {\n//   .radioStack {\n//     padding-top: 125px;\n//   }\n// }\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
